"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MontageSetProperties = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Montage Set properties that are used by the individual applications.
 */
class MontageSetProperties {
}
exports.MontageSetProperties = MontageSetProperties;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE;
MontageSetProperties[_a] = [
    'Id',
    'EchainId',
    'ArtNr',
    'Ausfuehrung',
    'BestTyp',
    'Bezeichnung',
    'Gewicht',
    'IsSet',
    'Opti',
];
MontageSetProperties[_b] = [
    'Id',
    'EchainId',
    'ArtNr',
    'Ausfuehrung',
    'BestTyp',
    'Bezeichnung',
    'Gewicht',
    'IsSet',
    'Opti',
];
//# sourceMappingURL=MontageSetProperties.js.map